import { z } from 'zod';
import { UserRole } from '../enums.js';
import { phoneSchema } from './common.js';
/** POST /api/auth/login — sotuvchi kirishi (BT §6.1, JWT). */
export const loginRequestSchema = z.object({
    phone: phoneSchema,
    password: z.string().min(6, 'v.password'),
});
export const authUserSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    phone: z.string(),
    role: z.nativeEnum(UserRole),
    storeId: z.string().uuid().nullable(),
    storeName: z.string().nullable(),
});
export const loginResponseSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    user: authUserSchema,
});
export const refreshRequestSchema = z.object({
    refreshToken: z.string().min(1),
});
//# sourceMappingURL=auth.js.map